import { render, staticRenderFns } from "./LearningResourceTable.vue?vue&type=template&id=02cff440&"
import script from "./LearningResourceTable.vue?vue&type=script&lang=ts&"
export * from "./LearningResourceTable.vue?vue&type=script&lang=ts&"
import style0 from "./LearningResourceTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports